import React, { useEffect, useState } from 'react'
import { list, getUserByGID, deleteGroupByID, addGroup } from '../api/group';
import Loader from '../components/Loader';
import { updateUserData, } from '../api/user';
import { useNavigate, } from 'react-router-dom';
import useUserStore from '../store/useUserStore';
import PopupModal from '../components/PopupModal';

export default function Group() {
    const { user } = useUserStore();
    const [showPopup, setShowPopup] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState({ "title": "", "text": "" })
    const [loading, setLoading] = useState(false);
    const [companyStatus, setCompanyStatus] = useState("");
    const [groupName, setGroupName] = useState("0");
    const [userList, setUserList] = useState([]);
    const [apiError, setApiError] = useState('');
    const [errorStatus, setErrorStatus] = useState("success");
    const navigate = useNavigate();
    const [option, setOption] = useState([{
        "id": "",
        "groupName": "Please select group"
    }]);
    const getGroupList = async () => {
        setLoading(true);
        let data = await list(user.db);
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setOption([{ id: 0, title: "Please select group" },
            ...data.data.data.map(obj => ({
                ...obj,
                title: `${obj.title}`,
                userList: obj.userList || [],
                status: obj.status || 'Active' // If status doesn't exist or is falsy, set it to 'Active'
            })).sort((a, b) =>
                a.title.localeCompare(b.title, undefined, { sensitivity: "base" })
            )
            ]);
        } else {
            setOption([{ id: 0, title: "Please select group" }]);
        }
    }
    const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
    useEffect(() => {
        getGroupList();
    }, []);

    useEffect(() => {
        const run = async () => {
            await delay(5000);
            setApiError("");
        };
        run();
    }, [apiError]);

    const getUserList = async (groupName) => {
        console.log("Group Name in getUserList", groupName);
        console.log("Option in getUserList", option);
        if (groupName !== "0") {
            console.log("Option", option.find(g => g.title === groupName.trim())?.userList || []);
            setUserList(option.find(g => g.title === groupName.trim())?.userList || []);
        } else {
            console.log("Group Name is 0");
            setUserList([]);
        }
    }
    const handleChange = async (e) => {
        const { value, } = e.target;
        const selectedOption = e.target.options[e.target.selectedIndex];
        const cStatus = selectedOption.getAttribute('cStatus');
        setCompanyStatus(cStatus);
        setGroupName(value);
        getUserList(value);

    }


    const handleUserUpdate = async (obj, fieldName) => {
        setLoading(true);
        let passObj = {
            _id: obj._id
        }
        if (fieldName === "password") {
            passObj["password"] = "Welcome1"
        } else if (fieldName === "status") {
            passObj["status"] = obj.status?.trim().toLowerCase() === "inactive" ? "Active" : "InActive"
            // passObj["status"] = obj.status
        } else if (fieldName === "loginattempt") {
            passObj["loginattempt"] = 0;
        }
        const updateRes = await updateUserData(passObj);
        setLoading(false);
        if (updateRes.status > 199 && updateRes.status <= 399) {
            let text = "User update successfully";
            if (fieldName === "loginattempt") {
                text = "Login attempts have been reset successfully."
            } else if (fieldName === "password") {
                text = "Password has been changed successfully."
            }

            setApiError(text);
            setErrorStatus("success")
            await getUserList(groupName);

        } else {
            setApiError(updateRes?.data?.message || "There is some technical issue,please try again after sometime")
            setErrorStatus("danger")

        }
    };
    const handleEditUser = async (obj) => {
        navigate(`/registration/${obj._id}/edit-user`)
    };
    const addUser = async () => {
        const result = option.find(c => c._id === groupName);
        navigate(`/registration/${result.clientID}`)
    };

    const deleteGroup = async () => {
        const result = option.find(c => c.title === groupName);
        console.log("Delete Group", result);

        setShowPopup(true);
        let text = 'Are you sure you want to delete the group? This action cannot be undone.'
        setPopUpMessage({
            "title": "Success",
            "text": text
        })
    }

    const updateCompanyInfo = async () => {

    }

    const handlerActiveInactive = async () => {
        const result = option.find(c => c.title === groupName);
        if (!result) return;
        const newStatus = companyStatus.trim().toLowerCase() === "active" ? "InActive" : "Active";
        setLoading(true);
        const updateRes = await addGroup({
            title: result.title,
            userList: result.userList || [],
            status: newStatus
        }, result._id);
        setLoading(false);
        if (updateRes.status > 199 && updateRes.status <= 399) {
            setCompanyStatus(newStatus);
            setApiError(`Group has been set to ${newStatus} successfully.`);
            setErrorStatus("success");
            getGroupList();
        } else {
            setApiError(updateRes?.data?.message || "There is some technical issue,please try again after sometime");
            setErrorStatus("danger");
        }
    }

    function toggleStatus(obj) {
        // Ensure a status field exists; do not flip values coming from the API.
        if (!('status' in obj) || obj.status === '' || obj.status === undefined) {
            obj.status = 'Inactive';
        }
        return obj;
    }
    const onConfirmAction = async () => {
        setShowPopup(false);
        // Here you can add the logic to delete the company after confirmation
        const result = option.find(c => c.title === groupName);
        console.log("Group deletion confirmed", groupName, result);
        setLoading(true);


        const data = await deleteGroupByID(result._id);
        setLoading(false);
        if (data.status > 199 && data.status <= 399) {
            setApiError(data.data.message)
            setErrorStatus('success')
            setUserList([]);
            getGroupList();
        } else {
            setApiError(data.data.message)
            setErrorStatus('danger')
        }
    }

    const handleGroupClick = () => {
        navigate('/group/add');
    }
    return (
        <>
            {loading && <Loader />}
            <PopupModal
                isOpen={showPopup}
                data={popUpMessage}
                onClose={() => {
                    setShowPopup(false)
                    setPopUpMessage({
                        "title": "",
                        "text": ""
                    })
                }}
                onConfirm={onConfirmAction}
            />
            <div className="content-wrapper">
                {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}

                <div className="page-header">
                    <h3 className="page-title"> Group </h3>
                    {apiError && <div className={`alert alert-${errorStatus} mb-4`}> {apiError}</div>}

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <button type="button" onClick={handleGroupClick} className="btn btn-primary me-2">Add Group</button>

                        </ol>
                    </nav>
                </div>
                <div className="form-group">
                    {/* <label htmlFor="exampleSelectGender">Group</label> */}
                    <select className="form-select" id="exampleSelectGender" name="groupName" value={groupName} onChange={handleChange}>
                        {option
                            .filter((obj) => obj.id !== "")
                            .map((obj) => (
                                <option key={obj.id} value={obj.id} cStatus={obj.status}>
                                    {obj.title}
                                </option>
                            ))}

                    </select>
                </div>
                <div>
                    {(groupName !== "0") &&
                        <nav aria-label="breadcrumb">
                            <button type="submit" className="btn btn-danger me-2" onClick={() => deleteGroup()}>Delete Group</button>
                            {/* <button type="submit" className="btn btn-success me-2" onClick={() => addUser()}>Add User</button> */}
                            <button className={`btn btn-${companyStatus.trim().toLowerCase() === "active" ? "success" : "danger"} me-2`} onClick={() => handlerActiveInactive()} >Group is {companyStatus}</button>

                        </nav>
                    }
                </div>
                <div className="col-lg-12 grid-margin stretch-card">

                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">User List</h4>



                            <div className="table-responsive ">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th> # </th>
                                            <th> Email </th>
                                            {/* <th> Status </th> */}
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {userList.map((obj, index) => (
                                            <tr key={obj._id} status={obj.status}>
                                                <td> {index + 1} </td>
                                                <td> {obj.email} </td>
                                                {/* <td> {obj?.status || ""} </td> */}

                                                <td>
                                                    <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleEditUser(obj)} className="btn btn-primary me-2" >Edit</button>
                                                    {/* <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleUserUpdate(obj, "password")} className="btn btn-danger me-2" >Reset Password</button> */}
                                                    <button style={{ marginLeft: "10px" }} type="button" onClick={() => handleUserUpdate(obj, "status")} className={`btn btn-${obj.status.trim().toLowerCase() === "active" ? "success" : "danger"} me-2`} >{obj.status}</button>


                                                </td>
                                            </tr>
                                        ))}



                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
